import axiosInstance from 'services/axiosMiddleware';

// services/pranayamma/updatePranayamma.js
export async function updatePranayamma(pranayama) {
  try {
    const { id, ...payload } = pranayama;

    if (!id) {
      throw new Error('Pranayama id is required');
    }

    // Fix: remove duplicated /pranayamma/
    const response = await axiosInstance.put(`/pranayamma/pranayamma/${id}`, payload);

    return response.data;
  } catch (error) {
    console.error('Update Pranayamma API Error:', error?.response?.data || error);
    throw error?.response?.data || error;
  }
}
